export default __webpack_public_path__ + "static/media/WarningTriangleIcon.e50952e9.svg";